import { render } from "./AppMenu.vue?vue&type=template&id=6d7fa820&bindings={\"collapseMenu\":\"data\"}"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"
script.render = render

export default script